import React from "react";
/** @jsxImportSource theme-ui */
import { Flex, Box, Heading } from "theme-ui";
import PropTypes from "prop-types";
import { DisplayIcon } from '../atoms';
import { colors, typography } from '../../styles/theme';

const styles = {
  banner: {
    flexDirection: ["column", "column", "row"],
    gap: "1rem",
    alignItems: "left",
    padding: ["1rem", "1.5rem", "1.5rem", "2rem"],
    borderRadius: "1rem",
  },
  icon: {
    marginRight: [null, "1rem", "1rem", "1rem"],
    marginBottom: ["1rem", null, null, null],
  },
  text: {
    heading: {
      ...typography.h6,
      color: colors.black,
      mb: '0.5rem'
    },
    paragraph: {
      ...typography.textMd400,
      color: colors.black,
    },
  },
};

const InfoBanner = ({
  heading,
  text,
  iconName,
  iconColor,
  type,
  customStyles,
  customIconStyles,
}) => {
  const theme = type === "alert" ? "secondaryOrange" : "primary";
  return (
    <Flex
      sx={{
        ...styles.banner,
        backgroundColor: colors[`${theme}100`],
        ...customStyles,
      }}
    >
      {iconName && (
        <DisplayIcon
          iconName={iconName}
          theme={theme}
          iconColor={iconColor}
          iconStyles={customIconStyles}
        />
      )}
      <Flex sx={{ flexDirection: "column", alignItems: "flex-start", width: ['100%', '100%', '80%', '80%'] }}>
        <Heading as="h6" sx={styles.text.heading}>
          {heading}
        </Heading>
        <Box sx={styles.text.paragraph}>{text}</Box>
      </Flex>
    </Flex>
  );
};

InfoBanner.defaultProps = {
  type: "default",
  customStyles: {},
  customIconStyles: {},
};

InfoBanner.propTypes = {
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  iconName: PropTypes.string,
  iconColor: PropTypes.string,
  type: PropTypes.oneOf(["default", "alert"]),
  customStyles: PropTypes.object,
  customIconStyles: PropTypes.object,
};

export default InfoBanner;
